<div class="btn-states" *ngIf="productsData">
    
    <button type="button" class="btn btn-primary btn-sm" (click)="changeState('APPROVED', reason)" *ngIf="check('PRODUCT_STATE_APPROVED')">
        <i class="bi bi-check-circle"></i> {{ 'APPROVE' | translate }}
    </button>
    <button type="button" class="btn btn-primary btn-sm" (click)="openDialogIndicateReasonForReject('REJECTED')" *ngIf="check('PRODUCT_STATE_REJECTED')">
        <i class="bi bi-dash-circle"></i> {{ 'REJECTED' | translate }}
    </button>

    <!-- <button type="button" class="btn btn-primary btn-sm" (click)="changeState('MODERATION', reason)" *ngIf="check('PRODUCT_STATE_MODERATION')">
        <i class="bi bi-file-earmark-break"> </i>{{ 'MODERATION' | translate }}
    </button> -->
    <button type="button" class="btn btn-primary btn-sm" (click)="changeState('PUBLISHED', reason)" *ngIf="check('PRODUCT_STATE_PUBLISHED')">
        <i class="bi bi-play-circle"></i> {{ 'PUBLISHED' | translate }}
    </button>

</div>